import React, { useRef } from "react";
import { projectData } from "../projects/const";
import AnimatedProductCard from "../components/AnimatedProductCard";

const Projects = ({ turnOffProject }) => {
  const scrollRef = useRef(null);

  return (
    <div className=" bg-transparent absolute w-full h-full overflow-y-auto p-4 sm:p-6 md:p-8">
      <div ref={scrollRef} className="scrolltotopprojects"></div>
      <h4 className="text-white text-center mt-16 sm:mt-[10vh] text-2xl sm:text-[4vw] tracking-tight font-mono">
        Projects <span className="text-gray-400">highlight</span>
      </h4>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
        {projectData.map((item, index) => (
          <div key={index} className="w-full">
            <AnimatedProductCard
              image={item.image}
              link={item.link}
              title={item.heading}
              description={item.desc}
            />
          </div>
        ))}
      </div>
      <div className="w-screen flex justify-center my-16">
        <button
          onClick={() => {
            scrollRef.current?.scrollIntoView({ behavior: "smooth" });
            turnOffProject();
          }}
          className="border-[#727272] font-medium text-xs mt-4 border text-[#727272] px-4 py-1 rounded-md"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default Projects;
